import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "../lib/cn.ts";

export const ScrollFade = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(function ScrollFade({ className, ...props }, ref) {
  return (
    <div
      ref={ref}
      className={cn(
        "overflow-auto [mask-image:linear-gradient(to_bottom,transparent,black_1rem,black_calc(100%-1rem),transparent)]",
        className,
      )}
      {...props}
    />
  );
});
